module.exports = __webpack_public_path__ + "static/media/long-image-1.5484d2bb.png";